import React from 'react';
import PropTypes from 'prop-types';
import { SearchSelect } from 'ui-kit';

export const PLACEHOLDER = 'Select location...';
export const NO_RESULTS_PLACEHOLDER = 'No location found.';

const toOption = ({
    id,
    name,
}) => ({
    value: id,
    label: name,
});

const SelectLocation = ({
    placeholder = PLACEHOLDER,
    noResultsPlaceholder = NO_RESULTS_PLACEHOLDER,
    disabled = false,
    value,
    locations = [],
    onChange = () => {}
}) => (
    <SearchSelect
        placeholder={placeholder}
        noResultsPlaceholder={noResultsPlaceholder}
        value={value}
        isDisabled={disabled}
        options={locations.map(toOption)}
        onChange={onChange}
    />
);

SelectLocation.propTypes = {
    placeholder: PropTypes.string,
    noResultsPlaceholder: PropTypes.string,
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    locations: PropTypes.array,
    onChange: PropTypes.func,
};

export default SelectLocation;
